import { firstNumber, firstPresent } from './chatArtifactValueUtils';

export function artifactExportScopeCount(artifact, companyIds = [], coreCompleteRowCount) {
  const action = (artifact?.actions || []).find((item) => {
    const key = firstPresent(item?.key, item?.product_key, item?.action_key);
    const kind = firstPresent(item?.kind, item?.type);
    return key === 'export_csv' || kind === 'export';
  });

  return firstNumber(
    coreCompleteRowCount,
    action?.scope_count,
    artifact?.stored_candidate_count,
    artifact?.cap_metadata?.stored_candidate_count,
    companyIds.length
  );
}

// Backend suggestions carry the export chip on every turn about a list; it belongs
// only on the turn that owns the artifact.
export function isExportSuggestion(suggestion) {
  return [suggestion?.suggestion_key, suggestion?.artifact_action_key, suggestion?.key]
    .includes('export_csv');
}

// The free export_csv action the backend attaches to an "export this" answer
// (sweep D8). Only this priced-at-zero export may render on a turn that merely
// references the list; every other export control stays on the owning turn.
export function isFreeExportAction(action) {
  return Boolean(
    action?.key === 'export_csv' &&
      action.enabled !== false &&
      action.credit_cost === 0 &&
      action.endpoint?.path
  );
}
